import React from "react";
import { ThriveIcon, IconLibrary } from "thrive-components";

export interface IPasswordValidationIndicators {
    validateCases: boolean;
    validateNumber: boolean;
    validateSpecialChar: boolean;
    validateLength: boolean;
}

const PasswordValidationIndicators = ({
    validateCases,
    validateNumber,
    validateSpecialChar,
    validateLength
}: IPasswordValidationIndicators) => {

    const renderItem = (isValid: boolean, text: string) => (
        <li className={isValid ? "valid" : "invalid"}>
            <ThriveIcon
                sizeInPx="10"
                iconName={isValid ? IconLibrary.CHECK : IconLibrary.DASH}
                color={isValid ? "var(--thriveGreen)" : "var(--thriveGreyDark)"}
            />
            {text}
        </li>
    );

    return (
        <ul className="password-includes-validation">
            {renderItem(validateCases, "Upper & lowercase letters")}
            {renderItem(validateNumber, "At least one number")}
            {renderItem(validateSpecialChar, "At least one special character")}
            {renderItem(validateLength, "Minimum 8 characters")}
        </ul>
    );
};

export default PasswordValidationIndicators;